import React from 'react';

import { makeClassNames } from '../../../utils/styles';

import './goal-badge.scss';

export interface IGoalBadge {
  goal?: number | '-';
  roundLabel?: string;
}

const classNames = (goal?: number | '-', roundLabel?: string) =>
  makeClassNames({
    badgeName: [goal !== undefined ? 'goal-badge' : '', roundLabel !== undefined ? 'label-badge' : ''], // "goal !== undefined" is to avoid truthy/falsy problem with "0" value!
  });

const GoalBadge = ({ /* istanbul ignore next: default value on mandatory field */ goal, roundLabel }: IGoalBadge) => {
  const cn = classNames(goal, roundLabel);

  return <span className={cn.badgeName}>{goal ?? roundLabel}</span>;
};

export default GoalBadge;
